import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';

import {
  mfaChallengeEnabledGuard,
  mfaSetupEnabledGuard,
} from './core/guards/mfa-enabled.guard';
import { dropReturnHintGuard } from './core/guards/return-hint.guard';
import {
  labsResolver,
  mfaContextResolver,
  securityPageGuard,
} from './core/guards/signed-in.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    title: 'Sign In',
    canActivate: [dropReturnHintGuard],
    loadComponent: () =>
      import('./features/auth/components/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'mfa',
    title: 'Verify It\'s You',
    canActivate: [dropReturnHintGuard, mfaChallengeEnabledGuard],
    resolve: { mfaContext: mfaContextResolver },
    loadComponent: () =>
      import(
        './features/auth/components/mfa-challenge/mfa-challenge.component'
      ).then((m) => m.MfaChallengeComponent),
  },
  {
    path: 'security/mfa',
    title: 'Two-Factor Authentication',
    canActivate: [mfaSetupEnabledGuard, securityPageGuard],
    loadComponent: () =>
      import(
        './features/auth/components/mfa-setup/mfa-setup.component'
      ).then((m) => m.MfaSetupComponent),
  },
  {
    path: 'labs',
    title: 'Choose Workspace',
    canActivate: [dropReturnHintGuard],
    resolve: { labs: labsResolver },
    loadComponent: () =>
      import(
        './features/auth/components/labs-picker/labs-picker.component'
      ).then((m) => m.LabsPickerComponent),
  },
  {
    path: 'forgot',
    title: 'Forgot Password',
    loadComponent: () =>
      import(
        './features/auth/components/forgot-password/forgot-password.component'
      ).then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'setup',
    title: 'Set Password',
    data: { mode: 'setup' },
    loadComponent: () =>
      import(
        './features/auth/components/password-form/password-form.component'
      ).then((m) => m.PasswordFormComponent),
  },
  {
    path: 'reset',
    title: 'Reset Password',
    data: { mode: 'reset' },
    loadComponent: () =>
      import(
        './features/auth/components/password-form/password-form.component'
      ).then((m) => m.PasswordFormComponent),
  },
  {
    path: 'unlock',
    title: 'Unlock Account',
    loadComponent: () =>
      import(
        './features/auth/components/unlock-account/unlock-account.component'
      ).then((m) => m.UnlockAccountComponent),
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    BrowserModule,
    BrowserAnimationsModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
